export default __webpack_public_path__ + "static/media/studio_new_logo.4f8070b3.png";